import React from "react";
import { getUrl } from "@outplayed/riot-assets";

const StatBar = (props) => {
  const { maxWidth, perc, color, swapIcon, value } = props;
  const width = maxWidth * perc;
  return (
    <div className="stat-bar-container">
      <div className="stat-bar" style={{ width: width, backgroundColor: color }} />
      {swapIcon && <img className="swap-icon" src={swapIcon} />}
      <div className="stat-val">{value}</div>
    </div>
  );
};

const PerformanceAnalysisBreakdownBarWidget = (props) => {
  const { chosenTier, stats } = props;

  return stats.map((stat, index) => {
    const perc1 = parseFloat(stat.first) >= parseFloat(stat.second) ? 1 : parseFloat(stat.first) / parseFloat(stat.second);
    const perc2 = parseFloat(stat.second) >= parseFloat(stat.first) ? 1 : parseFloat(stat.second) / parseFloat(stat.first);

    return (
      <div key={index}>
        <div className="bar-comparison-element">
          <div className="stat-container">
            <div className="KDA-text">{stat.label}</div>
            <StatBar maxWidth={380} perc={perc1} color={"#dba54b"} thousands={stat.thousands} value={stat.first} />
            <StatBar
              maxWidth={380}
              perc={perc2}
              color={"#08a6ff"}
              thousands={stat.thousands}
              value={stat.second}
              swapIcon={getUrl(`lol/performance_analysis/icons/${"swap_arrows.svg"}`)}
            />
          </div>
          <img className="icon" src={getUrl(`lol/performance_analysis/icons/${stat.iconImg}`)} />
        </div>
      </div>
    );
  });
};

export default PerformanceAnalysisBreakdownBarWidget;
